import Image from 'next/image'

import { cloudflareLoader } from '@mc/image-cloudflare'
import { Badge, Nameplate, TileCaption, TileOverlay } from '@mc/design-system'

import { nameplateOptimizedImage } from 'components/GlobalCarousel'
import Link from 'components/Link'
import { trackHomepageCarouselClick } from 'experiments/pen-4889_v1_hp_carousel_springboard/events'

import styles from './SpringboardCarouselTile.module.scss'

type SpringboardCarouselTileProps = {
  imageURL: string
  height: number
  width: number
  link: string
  title: string
  nameplateImage?: string
  showCategoryBadge?: boolean
  category?: string
  size?: 'sm' | 'lg'
}

export const SpringboardCarouselTile = ({
  link,
  title,
  nameplateImage,
  showCategoryBadge = false,
  category,
  size = 'lg',
  ...imageProps
}: SpringboardCarouselTileProps): JSX.Element => (
  <Link href={link} onClick={() => trackHomepageCarouselClick(link)}>
    <Image
      src={imageProps.imageURL}
      {...imageProps}
      alt={title}
      loader={cloudflareLoader}
      className='mc-corners--md'
      priority
      style={{ objectFit: 'cover', height: '100%', maxWidth: '100%' }}
    />
    <TileOverlay
      className='mc-corners--md'
      color='25, 28, 33'
      type='gradient-bottom'
    />
    <TileCaption position='center bottom' className='mc-pb-5'>
      <div
        className={`d-flex flex-column mc-gap-3 align-items-center ${size === 'lg' ? 'mc-px-4' : ''}`}
      >
        {nameplateImage ? (
          <Nameplate
            className={size === 'lg' ? 'mc-mx-7' : 'mc-mx-3'}
            size='small'
            src={nameplateOptimizedImage(nameplateImage)}
            data-testid='nameplateImage'
          />
        ) : (
          <p
            className={`mc-text--uppercase ${styles.subcatTitle} ${size === 'sm' ? styles.smallTile : ''}`}
          >
            {title}
          </p>
        )}
        {showCategoryBadge && <Badge kind='transparent'>{category}</Badge>}
      </div>
    </TileCaption>
  </Link>
)
